import { Facebook, Linkedin, Twitter } from "react-feather";
import { Link } from "react-router-dom";
import { CreateAccount, FacebookLink, LinkedIn, SignInWith, TwitterLink } from "../../../../../constants";
import { SocialLinksProp } from "../../../../../types/Others";
import { Fragment } from "react/jsx-runtime";
import { routes } from "../../../../../routers/routes";

const SocialLinks: React.FC<SocialLinksProp> = ({ logText, btnText }) => {
  return (
    <Fragment>
      <h6 className="text-muted mt-4 or">{SignInWith}</h6>
      <div className="social mt-4">
        <div className="btn-showcase">
          <Link to="https://www.linkedin.com/login" className="btn btn-light" target="_blank">
            <Linkedin /> {LinkedIn}
          </Link>
          <Link to="https://twitter.com/login?lang=en" className="btn btn-light" target="_blank">
            <Twitter /> {TwitterLink}
          </Link>
          <Link to="https://www.facebook.com/" className="btn btn-light" target="_blank">
            <Facebook /> {FacebookLink}
          </Link>
        </div>
      </div>
      <p className="mt-4 mb-0 text-center">
        {logText ? logText : "Don't have account?"}
        {!logText && !btnText ? (
          <Link className="ms-2" to={routes.Auth.Register.Simple}>
            {CreateAccount}
          </Link>
        ) : (
          <Link to={routes.Auth.Login.Simple} className="ms-2">
            {btnText}
          </Link>
        )}
      </p>
    </Fragment>
  );
};
export default SocialLinks;
